import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { useAnalytics } from "@/lib/useAnalytics";
import Landing from "@/pages/Landing";
import NakshatraDetailExpanded from "@/pages/NakshatraDetailExpanded";
import NakshatraGallery from "@/pages/NakshatraGallery";
import Admin from "@/pages/Admin";
import Calculator from "@/pages/Calculator";
import ShareNakshatra from "@/pages/ShareNakshatra";
import Pricing from "@/pages/Pricing";
import Compatibility from "@/pages/Compatibility";
import DashaForecast from "@/pages/DashaForecast";
import DailyChartActivation from "@/pages/DailyChartActivation";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Profile from "@/pages/Profile";
import MyReports from "@/pages/MyReports";
import KarmicAccessReport from "@/pages/KarmicAccessReport";
import LearnLanding from "@/pages/LearnLanding";
import ArticleList from "@/pages/ArticleList";
import ArticleDetail from "@/pages/ArticleDetail";
import NakshatraCalendar from "@/pages/NakshatraCalendar";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import DeleteAccount from "@/pages/DeleteAccount";

function AnalyticsTracker({ children }) {
  const { user } = useAuth();
  useAnalytics(user);
  return children;
}

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/nakshatras" element={<NakshatraGallery />} />
            <Route path="/nakshatras/:slug" element={<NakshatraDetailExpanded />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/compatibility" element={<Compatibility />} />
            <Route path="/dasha" element={<DashaForecast />} />
            <Route path="/daily-activation" element={<DailyChartActivation />} />
            <Route path="/calendar" element={<NakshatraCalendar />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/share/:slug/:pada" element={<ShareNakshatra />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-reports" element={<MyReports />} />
            <Route path="/karmic" element={<KarmicAccessReport />} />
            <Route path="/learn" element={<LearnLanding />} />
            <Route path="/learn/article/:articleSlug" element={<ArticleDetail />} />
            <Route path="/learn/:categorySlug" element={<ArticleList />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
          </Routes>
          </AnalyticsTracker>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F5F5F5",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
